// extracted by mini-css-extract-plugin
export default {"normal_button":"styles_normal_button__PD8+P","variantOne":"styles_variantOne__rh4uA","variantTwo":"styles_variantTwo__NdhTX"};